import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const sale = [
  {
    path: '/sale/client',
    name: 'sale-client-list',
    component: () => import('@/views/sale/client/client-list/ClientList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.CLIENTS,
    },
  },
  {
    path: '/sale/client/:id',
    name: 'sale-client-view',
    component: () => import('@/views/sale/client/client-view/ClientView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.CLIENTS,
      breadCrumb(context) {
        return [
          {
            text: 'clients',
            useI18n: true,
            to: { name: 'sale-client-list' },
          },
          {
            text: context.clientName,
            useI18n: false,
          },
        ]
      },
    },
  },
  comingSoonRoute({
    path: '/sale/leads',
    name: 'sale-leads',
    comingSoonKey: 'saleLeads',
    resource: PRIVATE.SALE.LEADS,
  }),
]

export default sale
